<template>
  <div class="col-md-6">
    <h1>Thu nhập thông tin</h1>

    <div style="width: 100%;">
      <div style=" display: flex; padding-bottom: 5px;font-size: 14px;">
        <div style="width: 40%; color: #76809B;">Merchant:</div>
        <div style="width: 60%;">MC Acc 1234</div>
      </div>
      <div style=" display: flex; padding-bottom: 5px;font-size: 14px;">
        <div style="width: 40%; color: #76809B;">Cửa hàng:</div>
        <div style="width: 60%;">Store ABCD</div>
      </div>
    </div>
    <b-card>
      <b-form>
        <!-- Merchant và Tên cửa hàng -->
        <!-- <b-form-group label="Merchant:" inline>
          <b-form-input placeholder="Tên Merchant Account" disabled></b-form-input>
        </b-form-group>
        <b-form-group label="Cửa hàng:" inline>
          <b-form-input placeholder="Tên Cửa hàng" disabled></b-form-input>
        </b-form-group> -->

        <b-form-group label="1. Cửa hàng có đang sử dụng POS của đơn vị khác không?">
          <b-form-radio-group v-model="posUsage" :options="OptionsRadio" name="pos" inlined>
          </b-form-radio-group>
          <!-- <b-form-radio-group v-model="posUsage" name="pos">
            <b-form-radio class="form-radio" value="có">Có</b-form-radio>
            <b-form-radio class="form-radio" value="không">Không</b-form-radio>
          </b-form-radio-group> -->
        </b-form-group>

        <b-form-group v-if="posUsage === 'yes'" label="Chọn đơn vị:">
          <b-form-checkbox-group v-model="posProviders" :options="posProvidersOptions" class="mb-3"
            inline></b-form-checkbox-group>

          <!-- <b-form-checkbox-group v-model="posProviders">
            <b-form-checkbox value="Payoo">Payoo</b-form-checkbox>
            <b-form-checkbox value="VNPAY">VNPAY</b-form-checkbox>
            <b-form-checkbox value="Smartpay">Smartpay</b-form-checkbox>
            <b-form-checkbox value="Khác">Khác</b-form-checkbox>
          </b-form-checkbox-group> -->
        </b-form-group>

        <b-form-group label="2. Cửa hàng có đang sử dụng hình thức trả góp của đơn vị khác không?">
          <b-form-radio-group v-model="payUsage" :options="OptionsRadio" name="pay" inlined>
          </b-form-radio-group>
        </b-form-group>

        <b-form-group label="3. Cửa hàng có đang sử dụng thanh toán QRCODE của đơn vị khác không?">
          <b-form-radio-group v-model="qrUsage" :options="OptionsRadio" name="qr" inlined>
          </b-form-radio-group>
        </b-form-group>

        <b-form-group label="4. Cửa hàng có đang tích hợp cổng thanh toán thẻ trên website không?">
          <b-form-radio-group v-model="webUsage" :options="OptionsRadio" name="web" inlined>
          </b-form-radio-group>
        </b-form-group>

        <b-form-group label="5. Cửa hàng có đang sử dụng phần mềm bán hàng của đơn vị khác không?">
          <b-form-radio-group v-model="appUsage" :options="OptionsRadio" name="app" inlined>
          </b-form-radio-group>
        </b-form-group>

        <b-form-group label="11. Lý do Cửa hàng đang không giao dịch qua mPOS hoặc giảm giao dịch:">
          <b-form-checkbox-group v-model="reasons" stacked>
            <b-form-checkbox class="checkbox-input" value="MC tạm dừng">MC tạm dừng</b-form-checkbox>
            <b-form-checkbox class="checkbox-input" value="MC thay đổi thông tin">MC thay đổi thông
              tin</b-form-checkbox>
            <b-form-checkbox class="checkbox-input" value="MC không biết cách sử dụng sản phẩm">MC không biết cách sử
              dụng sản phẩm</b-form-checkbox>
            <b-form-checkbox class="checkbox-input" value="MC chưa hiểu lợi ích của dịch vụ trả góp">MC chưa hiểu lợi
              ích của dịch vụ trả góp</b-form-checkbox>
            <b-form-checkbox class="checkbox-input"
              value="Mượn địa chỉ của cửa hàng khác để đăng ký tài khoản MPOS ( MC gian lận )">Mượn địa
              chỉ của cửa hàng khác để đăng ký tài khoản MPOS ( MC gian lận )</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>

        <!-- Các input để ghi chú -->
        <b-form-group label="12. Các vấn đề thường gặp khi sử dụng dịch vụ của mPOS:">
          <b-form-input v-model="issueNotes" placeholder="Nhập ghi chú..."></b-form-input>
        </b-form-group>
        <b-form-group label="13. Góp ý về sản phẩm, dịch vụ mPOS:">
          <b-form-input v-model="feedback" placeholder="Nhập góp ý..."></b-form-input>
        </b-form-group>
        <b-form-group label="14. Ghi chú sau khi thu thập thông tin:">
          <b-form-input v-model="notes" placeholder="Nhập ghi chú..."></b-form-input>
        </b-form-group>
      </b-form>
    </b-card>
  </div>
</template>

<style scoped src="@/assets/css/bootstrap4.3.1.min.css"></style>

<style>
.custom-control-label {
  padding-top: 5px;
}

.custom-control-inline {
  margin-right: 8px;
}
</style>
<script>
export default {
  data() {
    return {
      posUsage: null,
      payUsage: null,
      qrUsage: null,
      webUsage: null,
      appUsage: null,
      posProviders: [],
      reasons: [],
      issueNotes: '',
      feedback: '',
      notes: '',
      OptionsRadio: [
        { text: 'Có', value: 'yes' },
        { text: 'Không', value: 'no' },
      ],
      posProvidersOptions: [
        { text: 'Payoo', value: 'Payoo' },
        { text: 'VNPAY', value: 'VNPAY' },
        { text: 'Smartpay', value: 'Smartpay' },
        { text: 'Khác', value: 'Other' },
      ]
    };
  }
};
</script>
